import Image from 'next/image';
import React from 'react';

import { ShopProps } from '@/pages/solucoes-de-pagamentos-digitais';

import { Client, Container, GridClients } from './styles';

interface ClientsProps
  extends Omit<ShopProps['enterprisesCard'], 'id' | 'referId'> {
  id: string;
}

const Clients: React.FC<ClientsProps> = ({ id, title, images }) => {
  return (
    <Container id={id}>
      <h2 className="text-center heading-1">{title}</h2>
      <GridClients>
        {images.map(img => (
          <Client key={img.alternativeText}>
            <Image
              src={img.path}
              alt={img.alternativeText}
              width={img.width}
              height={img.height}
            />
          </Client>
        ))}
      </GridClients>
    </Container>
  );
};

export default Clients;
